<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    default: '新しいセッション',
  },
});
</script>

<template>
  <div class="flex items-center justify-center py-2" role="separator" :aria-label="props.label">
    <div class="h-px w-11/12 border-t border-dashed border-gray-400"></div>
    <span class="sr-only">{{ props.label }}</span>
  </div>
</template>
